module.exports = __webpack_public_path__ + "img/snow.31c34915.svg";